module.exports = __webpack_public_path__ + "static/media/porter-sans-inline-block.79337523.ttf";